import { lazy } from 'react';

export const TasksPage = lazy(() =>
  import('./tasks-view-page').then(({ TasksPage }) => ({
    default: TasksPage,
  }))
);
